import {
  CollapseButton,
  LabeledText,
} from '../../../../common/components/defaultUIComponents';
import { ChangeRequest } from '~/common/entities/ChangeRequest/ChangeRequestType';
import { Collapse, Flex, IconButton, Text } from '@chakra-ui/react';
import { Project } from '~/common/entities/Project/ProjectTypes';
import useTranslate from '../../../../common/utils/translate';
import JobTile from '../../../../common/components/JobTile';
import { DeleteIcon } from '@chakra-ui/icons';
import React from 'react';

type CombineStepsDetailsProps = {
  changeRequest: ChangeRequest;
  openCollapse: boolean;
  setOpenCollapse: (value: boolean) => void;
  toggleOpenDeleteDialog: () => void;
  projectOfJob: Project;
};

export const CombineStepsDetails: React.FC<CombineStepsDetailsProps> = ({
  changeRequest,
  openCollapse,
  setOpenCollapse,
  toggleOpenDeleteDialog,
  projectOfJob,
}) => {
  const toggleOpenCollapse = () => {
    setOpenCollapse(!openCollapse);
  };
  const translate = useTranslate();

  return (
    <>
      <Flex>
        <CollapseButton
          isOpen={openCollapse}
          toggleIsOpen={toggleOpenCollapse}
          mr={1}
        />
        <IconButton
          icon={<DeleteIcon />}
          onClick={toggleOpenDeleteDialog}
          aria-label={translate('changeRequest.delete')!}
          isRound
        />
      </Flex>
      <Collapse in={openCollapse}>
        <>
          {projectOfJob?.jobs &&
            changeRequest &&
            changeRequest.combine_with &&
            [
              projectOfJob.jobs.find((job) => job.id === changeRequest.job.id),
              projectOfJob.jobs.find(
                (job) => job.id === changeRequest.combine_with?.id,
              ),
              ...projectOfJob.jobs,
            ].map(
              (job, index) =>
                job && (
                  <>
                    {index === 0 && (
                      <Text fontWeight="semibold">
                        {translate('changeRequest.jobname')}
                      </Text>
                    )}
                    <JobTile
                      key={index === 0 ? -1 : index === 1 ? -2 : job.id}
                      job={job}
                      noIcons={true}
                      project={projectOfJob}
                      markThisJob={index == 0}
                      linkSteps={index == 0}
                      secondMergeJobIn={
                        index == 0 ? (changeRequest.combine_with?.id ?? -1) : -1
                      }
                      changeRequest={index == 0 ? changeRequest : null}
                    />
                    {index === 0 && (
                      <LabeledText
                        fontWeight="semibold"
                        label={'changeRequest.linkwith.Label'}
                      ></LabeledText>
                    )}
                    {index === 1 && (
                      <LabeledText
                        fontWeight="semibold"
                        label={'changeRequest.containingProjectname'}
                      >
                        {projectOfJob.name + ':'}
                      </LabeledText>
                    )}
                  </>
                ),
            )}
        </>
      </Collapse>
    </>
  );
};
